import React from 'react';

class Characters extends React.Component{
    render(){
        const {role,bloodstatus,name,house}= this.props
        return(
                <div className="cf">
                    <div className="fl w-25 tc pv5 mt4 ">
                        {name}
                    </div>
                    <div className="fl w-25 tc pv5 mt4 ">
                        {house}
                    </div>
                    <div className="fl w-25 tc pv5 mt4 ">
                        {role}
                    </div>
                    <div className="fl w-25 tc pv5 mt4 ">
                        {bloodstatus}
                    </div>
                </div>
        )
    }
}

export default Characters